import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=49746cef&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=49746cef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49746cef",
  null
  
)

export default component.exports